/**
 * emojiSlice: 이모지 리액션 상태 관리.
 *
 * v1 원본: redux/modules/emoji.js
 * v2 변환: RTK createSlice
 *
 * 이모지 타입: THUMBS_UP, CLAP_HAND, HUNDRED_POINT, OK,
 *              PARTY_POPPER, SMILE_WITH_HEART_EYES, FIRE, TWO_HEARTS
 */
import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import type { EmojiType, EmojiItem } from '@/types/store';

// re-export for backwards compatibility
export type { EmojiType, EmojiItem } from '@/types/store';

export interface EmojiState {
  emojiUserList: EmojiItem[];
  reactionLayerBottom: number;
}

const initialState: EmojiState = {
  emojiUserList: [],
  reactionLayerBottom: 0,
};

const emojiSlice = createSlice({
  name: 'emoji',
  initialState,
  reducers: {
    addEmoji(state, action: PayloadAction<EmojiItem>) {
      state.emojiUserList.push(action.payload);
    },
    removeEmoji(state, action: PayloadAction<string>) {
      state.emojiUserList = state.emojiUserList.filter((e) => e.id !== action.payload);
    },
    clearEmojis(state) {
      state.emojiUserList = [];
    },
    setReactionLayerBottom(state, action: PayloadAction<number>) {
      state.reactionLayerBottom = action.payload;
    },
    reset() {
      return initialState;
    },
  },
});

export const emojiActions = emojiSlice.actions;
export default emojiSlice.reducer;
